import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AvatarContextType {
  refreshTrigger: number;
  refreshAvatar: () => void;
}

interface ProfileContextType {
  profileRefreshTrigger: number;
  refreshProfile: () => void;
}

const AvatarContext = createContext<AvatarContextType | undefined>(undefined);
const ProfileContext = createContext<ProfileContextType | undefined>(undefined);

interface AvatarProviderProps {
  children: ReactNode;
}

interface ProfileProviderProps {
  children: ReactNode;
}

export const AvatarProvider: React.FC<AvatarProviderProps> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refreshAvatar = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <AvatarContext.Provider value={{ refreshTrigger, refreshAvatar }}>
      {children}
    </AvatarContext.Provider>
  );
};

export const ProfileProvider: React.FC<ProfileProviderProps> = ({ children }) => {
  const [profileRefreshTrigger, setProfileRefreshTrigger] = useState(0);

  const refreshProfile = () => {
    setProfileRefreshTrigger(prev => prev + 1);
  };

  return (
    <ProfileContext.Provider value={{ profileRefreshTrigger, refreshProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useAvatarRefresh = () => {
  const context = useContext(AvatarContext);
  if (context === undefined) {
    throw new Error('useAvatarRefresh must be used within an AvatarProvider');
  }
  return context;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useProfileRefresh = () => {
  const context = useContext(ProfileContext);
  if (context === undefined) {
    throw new Error('useProfileRefresh must be used within a ProfileProvider');
  }
  return context;
};
